<template>
  <div :class="['bg-purple','el-row',{'panel-border': border}]" style="padding: 5px 15px;">
    <div class="el-col el-col-24">
      <div class="Htitle-text" v-if="label||title" v-html="label||title"></div>
      <p class="Htitle-text-bz" v-if="subTitle">{{subTitle}}</p>
      <div class="panel-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
      name: "Panel",
      props: {
        label: String,
        title: {
          type: String,
          default: ''
        },
        subTitle: {
          type: String,
          default: ''
        },
        border: {
          type: Boolean,
          default: false
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Panel.vue